import types from "./types";

const initialState = {
    error: null,
    loading: false,
    loaded: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.SEND_CREATE_SCRATCH:{
            return {
                ...state,
                loading: true,
                loaded: false
            };
        }
        case types.SEND_CREATE_SCRATCH_FAIL: {
            return {
                ...state,
                loading: false,
                loaded: false
            };
        }
        case types.SEND_CREATE_SCRATCH_SUCCESS: {
            return {
                ...state,
                loading: false,
                loaded: true
            };
        }
        default: {
            return state;
        }
    }
};
